import { render } from "./confirmdescription.vue?vue&type=template&id=67f889c7"
import script from "./confirmdescription.vue?vue&type=script&lang=js"
export * from "./confirmdescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__